import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  useGetReasonChargeback,
  useGetServiceDetailsList,
  usePostPaymentReverse,
} from '@/modules/Users/queries/PatientQueries/Patient.queries'
import { useModalStore } from '@/store/useModal'

const usePaymentReverseModal = () => {
  const attendanceId = useParams()
  const { modalOpen, closeModal } = useModalStore()

  const [reason, setReason] = useState('')
  const [details, setDetails] = useState('')

  const { reasonChargeback } = useGetReasonChargeback()
  const { serviceDetailsList } = useGetServiceDetailsList(attendanceId.userId)

  const { paymentReverseIsLoading, paymentReverseMutation } =
    usePostPaymentReverse()

  const disabledButton = useMemo(() => {
    return details?.length > 20 && Boolean(reason)
  }, [details.length, reason])

  const handleReason = useCallback(
    value => {
      const filteredReasons = reasonChargeback
        ?.filter(item => item?.value === value)
        ?.map(item => item?.key)
      setReason(String(filteredReasons))
    },
    [reasonChargeback],
  )

  const handlePaymentReverse = useCallback(() => {
    const params = {
      idPacientePagamento: serviceDetailsList?.patientPayment?.id,
      motivo: reason,
      detalhes: details,
    }
    paymentReverseMutation(params)
  }, [
    serviceDetailsList?.patientPayment?.id,
    details,
    paymentReverseMutation,
    reason,
  ])

  return {
    modalOpen,
    closeModal,
    reasonChargeback,
    serviceDetailsList,
    disabledButton,
    setReason,
    setDetails,
    handlePaymentReverse,
    paymentReverseIsLoading,
    handleReason,
  }
}

export default usePaymentReverseModal
